import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3169098e&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=3169098e&prod&scoped=true&lang=css&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=3169098e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169098e",
  null
  
)

export default component.exports